export default __webpack_public_path__ + "static/media/by-sa.a960dfca.svg";